import userRoles from 'constants/userRoles';
import { useCallback, useEffect, useState } from 'react';
import loggedInUserSelectors from 'reducers/loggedInUser/selectors';
import _refiner from 'refiner-js';
import { isProduction } from 'utils/getEnvironment';
import useReduxSelector from 'utils/useReduxSelector';
import { REFINER_TRACK_EVENTS } from './types';

const useRefiner = () => {
  const org = useReduxSelector(loggedInUserSelectors.currentOrganization);
  const user = useReduxSelector(loggedInUserSelectors.employeeDetails);
  const isOrgActive = Boolean(org?.isActive);
  const [isRefinerInitialized, setRefinerInitialized] = useState(false);

  // Track an event using Refiner
  const trackEvent = useCallback(
    (eventName: REFINER_TRACK_EVENTS): void => {
      // The event cannot be tracked until Refiner is initialized
      if (!isProduction() || !isRefinerInitialized) return;

      _refiner('trackEvent', eventName);
    },
    [isRefinerInitialized],
  );

  useEffect(() => {
    if (!org || !isOrgActive || !user || !isProduction()) return;

    const isAdmin = user?.userRoleId === userRoles.ADMIN;

    if (!isAdmin) return;

    _refiner('setProject', '0e9e32d0-4e60-11ef-a4b1-61176804fd1c');
    const orgId = org?.id;
    const userOrgId = user?.id;

    _refiner('identifyUser', {
      id: userOrgId,
      userOrgId: userOrgId,
      orgId: orgId,
      isAdmin: isAdmin,
    });

    // Mark Refiner as initialized after identifyUser call
    setRefinerInitialized(true);
  }, [org, isOrgActive, user]);

  return { trackEvent };
};

export default useRefiner;
